import React, { useEffect } from 'react';
import { Modal, Form, Input, DatePicker, Button, Space, Switch, Select } from 'antd';
// import { useTranslation } from 'react-i18next';
import { Meal, UpdateMealDto, mealTypes } from '../../../../types/meal.types';
import { useMealActions } from '../../../../hooks/useMeals';
import { handleApiError } from '../../../../utils/errorHandler';
// import dayjs from 'dayjs';

const { TextArea } = Input;

interface UpdateMealModalProps {
  visible: boolean;
  meal: Meal | null;
  onCancel: () => void;
  onSuccess: () => void;
}

const UpdateMealModal: React.FC<UpdateMealModalProps> = ({
  visible,
  meal,
  onCancel,
  onSuccess
}) => {
  // const { t } = useTranslation();
  const [form] = Form.useForm();
  const { updateMeal, loading } = useMealActions();

  useEffect(() => {
    if (visible && meal) {
      form.setFieldsValue({
        title: meal.title,
        description: meal.description,
        type: meal.type,
        // date: dayjs(meal.date),
        // isActive: meal.isActive
      });
    }
  }, [visible, meal, form]);

  const handleSubmit = async (values: any) => {
    if (!meal) return;

    try {
      const updateData: UpdateMealDto = {
        title: values.title,
        description: values.description,
        type: values.type,
        // date: values.date.format('YYYY-MM-DD'),
        // isActive: values.isActive
      };

      const result = await updateMeal(meal.id, updateData);
      if (result) {
        form.resetFields();
        onSuccess();
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Yemek Düzenle"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="title"
          label="Yemek Adı"
          rules={[
            { required: true, message: 'Yemek adı gereklidir!' },
            { min: 2, message: 'Yemek adı en az 2 karakter olmalıdır!' }
          ]}
        >
          <Input placeholder="Örn: Köfte Pilav" />
        </Form.Item>

        <Form.Item
          name="description"
          label="Açıklama"
          rules={[
            { max: 500, message: 'Açıklama en fazla 500 karakter olabilir!' }
          ]}
        >
          <TextArea
            rows={4}
            placeholder="Yemek hakkında detaylı bilgi giriniz..."
            showCount
            maxLength={500}
          />
        </Form.Item>

        <Form.Item
          name="type"
          label="Yemek Türü"
          rules={[
            { required: true, message: 'Yemek türü seçimi gereklidir!' }
          ]}
        >
          <Select
            options={mealTypes}
            placeholder="Yemek türü seçiniz"
          />
        </Form.Item>

        {/* <Form.Item
          name="date"
          label="Tarih"
          rules={[
            { required: true, message: 'Tarih seçimi gereklidir!' }
          ]}
        >
          <DatePicker
            style={{ width: '100%' }}
            format="DD.MM.YYYY"
            placeholder="Tarih seçiniz"
          />
        </Form.Item> */}



        {/* <Form.Item
          name="isActive"
          label="Durum"
          valuePropName="checked"
        >
          <Switch
            checkedChildren="Aktif"
            unCheckedChildren="Pasif"
          />
        </Form.Item> */}

        <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
          <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
            <Button onClick={handleCancel}>
              İptal
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Güncelle
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateMealModal;